<template>
  <div class="seek_list_page">
    <div class="filter-container" ref="tools">
      <el-form
        :inline="true"
        :model="formInline"
        class="search-container"
        :label-width="labelWidth"
      >
        <!-- 索赔单号 -->
        <el-form-item :label="$t('climant.climantNumber') + ':'">
          <el-input
            v-model="formInline.claimStatementId"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 索赔单状态 -->
        <el-form-item :label="$t('climant.climantStatus') + ':'">
          <el-select v-model="formInline.status" filterable clearable>
            <el-option :label="$t('home.all')" value=""></el-option>
            <el-option :label="$t('climant.noSubmit')" value="0"></el-option>
            <el-option
              :label="$t('cart.audit')"
              value="1,3,4,15,16,17,18,21"
            ></el-option>
            <el-option :label="$t('home.passed')" value="19"></el-option>
            <!-- <el-option :label="$t('climant.dys')" value="1,4"></el-option>
              <el-option
                :label="$t('climant.dzs')"
                value="3,15,16,17,18,19,21"
              ></el-option> -->
            <el-option :label="$t('climant.rejected')" value="2"></el-option>
            <!-- <el-option :label="$t('climant.zrpd')" value="6,7"></el-option> -->
            <el-option
              :label="$t('climant.claimsRejected')"
              value="5"
            ></el-option>
            <el-option :label="$t('climant.djs')" value="11"></el-option>
            <el-option
              :label="$t('climant.settleAccounts')"
              value="12"
            ></el-option>
            <el-option :label="$t('home.canceled')" value="13"></el-option>
            <el-option :label="$t('climant.ych')" value="14"></el-option>
          </el-select>
        </el-form-item>
        <!-- 配件编码 -->
        <el-form-item :label="$t('home.accessoryCode') + ':'">
          <el-input
            v-model="formInline.faultPartNumber"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 配件名称 -->
        <el-form-item :label="$t('home.accessoryName') + ':'">
          <el-input
            v-model="formInline.faultPartName"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 客户索赔单号 -->
        <el-form-item :label="$t('home.customerClaimNumber') + ':'">
          <el-input
            v-model="formInline.customerClaimNumber"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <!-- 索赔类型 -->
        <el-form-item :label="$t('claimantKd.spType') + ':'">
          <el-select v-model="formInline.claimType" filterable clearable>
            <el-option :label="$t('claimantKd.yssh')" :value="1"> </el-option>
            <el-option :label="$t('claimantKd.hc')" :value="2"> </el-option>
            <el-option :label="$t('claimantKd.zlwt')" :value="3"> </el-option>
            <el-option :label="$t('claimantKd.ztbf')" :value="4"> </el-option>
            <el-option :label="$t('claimantKd.qt')" :value="5"> </el-option>
          </el-select>
        </el-form-item>

        <!-- 申请时间 -->
        <el-form-item :label="$t('climant.applicationDate') + ':'">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('cart.startDate')"
            :end-placeholder="$t('cart.endDate')"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div></div>
        <div>
          <el-button type="primary" class="primary-btn" @click="onSearch">
            <i class="subSearch-icon"></i>
            {{ $t("home.query") }}
          </el-button>
          <el-button class="primary-btn" plain @click="handleResetQuery">
            <i class="el-icon-refresh-right"></i>
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <el-tabs
      v-model="activeName"
      class="tabs-container"
      @tab-click="handleClick"
    >
      <el-tab-pane :label="$t('home.all')" name="all"></el-tab-pane>
      <el-tab-pane :label="$t('climant.drafts')" name="0"></el-tab-pane>
      <el-tab-pane :label="$t('climant.rejected')" name="2"></el-tab-pane>
      <el-tab-pane :label="$t('climant.claimsRejected')" name="5"></el-tab-pane>
      <el-tab-pane
        :label="$t('climant.settleAccounts')"
        name="12"
      ></el-tab-pane>
    </el-tabs>
    <div v-if="activeName == '12'" class="list">
      <div class="table-btn" >
        <el-button
          type="primary"
          class="primary-btn"
          icon="el-icon-download"
          @click="handleExport(3)"
          >{{ $t("climant.exportSpmxspd") }}
        </el-button>
        <el-button
          type="primary"
          plain
          class="primary-btn"
          icon="el-icon-download"
          @click="handleExport(4)"
          >{{ $t("climant.exportSpmxgzj") }}
        </el-button>
      </div>
      <el-table
        key="1"
        stripe
        border
        ref="singleTable1"
        :data="tableData"
        highlight-current-row
        :max-height="maxHeight"
        :row-class-name="tableRowClassName"
      >
        <!-- 序号 -->
        <el-table-column
          type="index"
          :label="$t('cart.xh')"
          width="50"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 索赔单号 -->
        <el-table-column
          property="claimStatementId"
          :label="$t('climant.climantNumber')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 客户索赔单号 -->
        <el-table-column
          property="customerClaimNumber"
          :label="$t('home.customerClaimNumber')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 配件编码 -->
        <el-table-column
          property="faultPartNumber"
          :label="$t('home.accessoryCode')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 配件名称 -->
        <el-table-column
          property="faultPartName"
          :label="$t('home.accessoryName')"
          min-width="200"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 索赔类型 -->
        <el-table-column
          property="claimType"
          :label="$t('claimantKd.spType')"
          min-width="200"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.claimType == 1">{{
              $t("claimantKd.yssh")
            }}</span>
            <span v-if="scope.row.claimType == 2">{{
              $t("claimantKd.hc")
            }}</span>
            <span v-if="scope.row.claimType == 3">{{
              $t("claimantKd.zlwt")
            }}</span>
            <span v-if="scope.row.claimType == 4">{{
              $t("claimantKd.ztbf")
            }}</span>
            <span v-if="scope.row.claimType == 5">{{
              $t("claimantKd.qt")
            }}</span>
          </template>
        </el-table-column>
        <!-- 审核状态 -->
        <el-table-column
          property="auditResultDisplay"
          :label="$t('cart.auditStatus')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">
              <!-- 待提交 -->
              {{ $t("climant.noSubmit") }}
            </span>
            <span
              v-else-if="
                scope.row.status == 1 ||
                scope.row.status == 3 ||
                scope.row.status == 4 ||
                scope.row.status == 3 ||
                scope.row.status == 15 ||
                scope.row.status == 16 ||
                scope.row.status == 17 ||
                scope.row.status == 18 ||
                scope.row.status == 21
              "
            >
              <!-- 待审核 -->
              {{ $t("cart.audit") }}
            </span>
            <span v-else-if="scope.row.status == 19">
              <!-- 已通过：待确认（责任主体） -->
              {{ $t("home.passed") }}
            </span>
            <span v-else-if="scope.row.status == 2">
              <!-- 驳回（预审） -->
              {{ $t("climant.rejected") }}
            </span>
            <span v-else-if="scope.row.status == 5">
              <!-- 已拒赔 -->
              {{ $t("climant.claimsRejected") }}
            </span>
            <span v-else-if="scope.row.status == 11">
              <!-- 待结算 -->
              {{ $t("climant.djs") }}
            </span>
            <span v-else-if="scope.row.status == 12">
              <!-- 已结算 -->
              {{ $t("climant.settleAccounts") }}
            </span>
            <span v-else-if="scope.row.status == 13">
              <!-- 已取消 -->
              {{ $t("home.canceled") }}
            </span>
            <span v-else-if="scope.row.status == 14">
              <!-- 已撤回 -->
              {{ $t("climant.ych") }}
            </span>
          </template>
        </el-table-column>
        <!-- 维修方案 -->
        <el-table-column
          prop="repairPlan"
          :label="$t('climant.wxfa')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.repairPlanList.indexOf(0) ? $t("climant.wx") + "," : ""
            }}
            {{
              scope.row.repairPlanList.indexOf(1) ? $t("climant.gh") + "," : ""
            }}
            {{ scope.row.repairPlanList.indexOf(2) ? $t("claimantKd.bf") : "" }}
          </template>
        </el-table-column>

        <!-- 工时费 -->
        <el-table-column
          prop="totalCostOfWork"
          :label="$t('climant.gsf')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 运费 -->
        <el-table-column
          prop="freight"
          :label="$t('climant.transportationCost')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 关税 -->
        <el-table-column
          prop="tariff"
          :label="$t('climant.customs')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 材料费 -->
        <el-table-column
          prop="materialTotalCost"
          :label="$t('climant.materialCost')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 其他费用 -->
        <el-table-column
          prop="otherTotalCost"
          :label="$t('climant.otherCost')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 一次索赔总费用 -->
        <el-table-column
          prop="claimTotalCost"
          :label="$t('climant.ycspfy')"
          min-width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 结算币种 -->
        <el-table-column
          prop="currency"
          :label="$t('climant.currency')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.currency == 0 ? "CNY" : "USD" }}
          </template>
        </el-table-column>
        <!-- 结算人 -->
        <el-table-column
          prop="settlementStaff"
          :label="$t('climant.jsr')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 结算日期 -->
        <el-table-column
          prop="settlementTime"
          :label="$t('climant.jsrq')"
          min-width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="$t('cart.operate')"
          align="center"
          width="110"
          fixed="right"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button type="text" @click="handleDetail(scope.row)">{{
              $t("operate.view")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else class="list">
      <div class="table-btn" >
        <!-- 申请索赔 -->
        <el-button
          type="primary"
          class="primary-btn"

          icon="el-icon-plus"
          @click="handleAddOrEdit()"
          >{{ $t("home.applyClaim") }}</el-button
        >
        <el-button
          type="primary"
          class="primary-btn"
          plain
          icon="el-icon-download"
          @click="handleExport(1)"
          >{{ $t("cart.export") }}</el-button
        >
      </div>
      <el-table
        key="2"
        stripe
        border
        ref="singleTable2"
        :data="tableData"
        highlight-current-row
        :row-class-name="tableRowClassName"
        :max-height="maxHeight"
      >
        <!-- 序号 -->
        <el-table-column
          type="index"
          :label="$t('cart.xh')"
          width="50"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 索赔单号 -->
        <el-table-column
          property="claimStatementId"
          :label="$t('climant.climantNumber')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 客户索赔单号 -->
        <el-table-column
          property="customerClaimNumber"
          :label="$t('home.customerClaimNumber')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 配件编码 -->
        <el-table-column
          property="faultPartNumber"
          :label="$t('home.accessoryCode')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 配件名称 -->
        <el-table-column
          property="faultPartName"
          :label="$t('home.accessoryName')"
          min-width="200"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>

        <!-- 索赔类型 -->
        <el-table-column
          property="claimType"
          :label="$t('claimantKd.spType')"
          min-width="200"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.claimType == 1">{{
              $t("claimantKd.yssh")
            }}</span>
            <span v-if="scope.row.claimType == 2">{{
              $t("claimantKd.hc")
            }}</span>
            <span v-if="scope.row.claimType == 3">{{
              $t("claimantKd.zlwt")
            }}</span>
            <span v-if="scope.row.claimType == 4">{{
              $t("claimantKd.ztbf")
            }}</span>
            <span v-if="scope.row.claimType == 5">{{
              $t("claimantKd.qt")
            }}</span>
          </template>
        </el-table-column>
        <!-- 申请时间 -->
        <el-table-column
          property="createTime"
          min-width="160"
          :label="$t('climant.applicationDate')"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 审核状态 -->
        <el-table-column
          property="auditResultDisplay"
          :label="$t('cart.auditStatus')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">
              <!-- 待提交 -->
              {{ $t("climant.noSubmit") }}
            </span>
            <span
              v-else-if="
                scope.row.status == 1 ||
                scope.row.status == 3 ||
                scope.row.status == 4 ||
                scope.row.status == 3 ||
                scope.row.status == 15 ||
                scope.row.status == 16 ||
                scope.row.status == 17 ||
                scope.row.status == 18 ||
                scope.row.status == 21
              "
            >
              <!-- 待审核 -->
              {{ $t("cart.audit") }}
            </span>
            <span v-else-if="scope.row.status == 19">
              <!-- 已通过：待确认（责任主体） -->
              {{ $t("home.passed") }}
            </span>
            <span v-else-if="scope.row.status == 2">
              <!-- 驳回（预审） -->
              {{ $t("climant.rejected") }}
            </span>
            <span v-else-if="scope.row.status == 5">
              <!-- 已拒赔 -->
              {{ $t("climant.claimsRejected") }}
            </span>
            <span v-else-if="scope.row.status == 11">
              <!-- 待结算 -->
              {{ $t("climant.djs") }}
            </span>
            <span v-else-if="scope.row.status == 12">
              <!-- 已结算 -->
              {{ $t("climant.settleAccounts") }}
            </span>
            <span v-else-if="scope.row.status == 13">
              <!-- 已取消 -->
              {{ $t("home.canceled") }}
            </span>
            <span v-else-if="scope.row.status == 14">
              <!-- 已撤回 -->
              {{ $t("climant.ych") }}
            </span>
          </template>
        </el-table-column>
        <!-- 审核时间 -->
        <el-table-column
          property="auditTime"
          :label="$t('climant.examineDate')"
          min-width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="$t('cart.operate')"
          :width="{ ru: 380, en: 220, vi: 240, es: 240 }[$i18n.locale] || 200"
          fixed="right"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button type="text" @click="handleDetail(scope.row)">{{
              $t("operate.view")
            }}</el-button>
            <!-- 编辑 -->
            <el-button
              v-if="
                scope.row.status == 0 ||
                scope.row.status == 2 ||
                scope.row.status == 14
              "
              type="text"
              @click="handleAddOrEdit(scope.row)"
              >{{ $t("home.edit") }}</el-button
            >
            <!-- 提交 -->
            <el-button
              v-if="scope.row.status == 0 || scope.row.status == 2"
              type="text"
              @click="
                handleChangeStatus(scope.row, '1', 'climant.submitClimant')
              "
              >{{ $t("seek.submit") }}</el-button
            >
            <!-- 撤回 -->
            <el-button
              v-if="
                scope.row.status == 1 ||
                scope.row.status == 3 ||
                scope.row.status == 4 ||
                scope.row.status == 21
              "
              type="text"
              @click="
                handleChangeStatus(scope.row, '14', 'climant.revocateClimant')
              "
              >{{ $t("operate.revocate") }}</el-button
            >
            <!-- 取消 -->
            <el-button
              v-if="
                scope.row.status == 0 ||
                scope.row.status == 1 ||
                scope.row.status == 2 ||
                scope.row.status == 3 ||
                scope.row.status == 4 ||
                scope.row.status == 14 ||
                scope.row.status == 21
              "
              type="text"
              @click="
                handleChangeStatus(scope.row, '13', 'climant.cancelClimant')
              "
              >{{ $t("seek.cancel") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- </div> -->
    <div class="fenye" >
      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="changePage"
      />
    </div>
  </div>
</template>
<script>
import { settlementExport } from "@/api/seek";
import { setStorage, setStorageNew } from "@/util/localStor";
import {
  exportClaim,
  claimantList,
  toSubmitClaimant,
  cancelClaimant,
  revokeClaimant,
} from "@/api/kdsuopei";
import { getDownloadFiles } from "@/util/downFile";


export default {
  data() {
    const { data, pageNum, pageSize } = this.$route.query.searchObj
      ? JSON.parse(this.$route.query.searchObj)
      : {};

    return {
      activeName: "all", // tab栏激活项
      formInline: {
        claimStatementId: "", //索赔单号
        status: "",
        faultPartName: "",
        faultPartNumber: "",
        customerClaimNumber: "",
        claimType: "",
        date: "",
      },
      nowSearch: {
        claimStatementId: "", //索赔单号
        status: "",
        faultPartName: "",
        faultPartNumber: "",
        createTimeStart: "",
        createTimeEnd: "",
        claimType: "",
      },
      tableData: [],
      page: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 30,
      total: 0,
      modelList: [],
      recordsSearchObj: data,
      maxHeight: null,
      // tableHeight: 300, //表格动态高度
      // screenHeight: 0, //内容区域高度
    };
  },

  mounted() {
    this.nowSearch = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.nowSearch;
    this.formInline = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.formInline;
    this.getList();

    // this.updateWindowHeight();
    // window.addEventListener("resize", this.updateWindowHeight);
  },
  watch: {
    "$i18n.locale"(newValue, oldValue) {
      let num = 0;
      if (newValue !== "zh") num = 30;
      // this.updateWindowHeight(num);
    },
  },
  computed: {
    labelWidth() {
      const widthMap = {
        zh: "100px",
        en: "185px",
        ru: "180px",
        fa: "150px",
        vi: "205px",
        es: "250px",
      };
      return widthMap[this.$i18n.locale] || "150px";
    },
  },
  methods: {
    // updateWindowHeight(num) {
    //   if (num) {
    //     this.tableHeight =
    //       this.screenHeight - (this.$refs.stickybox.offsetHeight + 30 + num);
    //   } else {
    //     this.tableHeight =
    //       this.screenHeight - (this.$refs.stickybox.offsetHeight + 30);
    //   }
    //   this.screenHeight = window.innerHeight;

    //   this.$nextTick(() => {
    //     if (this.activeName == 12) {
    //       this.$refs.singleTable1.doLayout();
    //     } else {
    //       this.$refs.singleTable2.doLayout();
    //     }
    //   });
    // },
    // 切换tab状态
    handleClick() {
      this.page = 1;
      this.pageSize = 30;
      this.nowSearch.status = this.activeName == "all" ? "" : this.activeName;
      this.getList();
    },
    // 未读消息数表格行样式标注
    tableRowClassName({ row, rowIndex }) {
      if (row.notificationCount > 0) {
        return "warning-row";
      }
      return "";
    },
    // 每页显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    // 翻页
    changePage(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    // 记录当前列表搜索条件
    recordSearchObj() {
      this.$router.replace(
        "/kdClaimant?searchObj=" +
          JSON.stringify({
            data: {
              ...this.nowSearch,
              date: this.nowSearch.createTimeStart
                ? [
                    this.nowSearch.createTimeStart.split(" ")[0],
                    this.nowSearch.createTimeEnd.split(" ")[0],
                  ]
                : "",
            },
            pageNum: this.page,
            pageSize: this.pageSize,
          })
      );
    },
    // 查看详情
    handleDetail(data) {
      this.recordSearchObj();
      this.$router.push({
        name: "kdClaimantDetail",
        query: {
          unread: data.notificationCount,
          claimantId: data.claimStatementId,
        },
      });
      setStorage("claimantData", data);
    },
    // 搜索
    onSearch() {
      this.page = 1;
      this.pageSize = 30;
      this.nowSearch.status = this.formInline.status;
      this.nowSearch.claimStatementId = this.formInline.claimStatementId;
      this.nowSearch.faultPartNumber = this.formInline.faultPartNumber;
      this.nowSearch.faultPartName = this.formInline.faultPartName;
      this.nowSearch.claimType = this.formInline.claimType;
      if (this.formInline.date) {
        this.nowSearch.createTimeStart = this.formInline.date[0] + " 00:00:00";
        this.nowSearch.createTimeEnd = this.formInline.date[1] + " 23:59:59";
      } else {
        this.nowSearch.createTimeStart = "";
        this.nowSearch.createTimeEnd = "";
      }
      this.nowSearch.customerClaimNumber = this.formInline.customerClaimNumber;
      this.getList();
    },
    // 获取列表
    async getList() {
      const query = {
        data: {
          ...this.nowSearch,
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize,
        },
      };

      const res = await claimantList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        // this.updateWindowHeight();
      } else {
        this.$DonMessage.warning(res.message);
      }
      this.getTableHighest(this, "maxHeight");
    },
    // 重置查询条件
    handleResetQuery() {
      // 可能是因为data里面的constxxx前面那一段 导致this.$options.data()报错，没法使用这个重置
      // this.formInline = Object.assign({}, this.$options.data()?.formInline);
      (this.formInline = {
        status: "",
        claimStatementId: "",
        faultPartNumber: "",
        faultPartName: "",

        claimType: "",
        date: "",
      }),
        this.onSearch();
    },
    // 申请索赔
    handleAddOrEdit(data = {}) {
      this.recordSearchObj();
      setStorageNew("claimantData", data);
      this.$router.push("/addKdClaimant");
    },
    // 导出
    async handleExport(type) {
      const query = {
        data: {
          ...this.nowSearch,
          exportType: type,
          languageType: this.$i18n.locale,
        },
      };
      var res = {};
      if (type == 2) {
        res = await settlementExport(query);
      } else {
        res = await exportClaim(query);
      }
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success(this.$t("request.exportOrder"));
      }
    },
    // 提交 | 取消 | 撤回
    async handleChangeStatus(row, status, title) {
      await this.$confirm(
        `${this.$t(title) + ":" + row.claimStatementId}？`,
        this.$t("request.tips"),
        {
          cancelButtonClass: "confirm-btn-close",
          confirmButtonClass: "confirm-btn-confirm",
        }
      );
      var res = {};
      if (title == "climant.cancelClimant") {
        res = await cancelClaimant({
          data: {
            claimStatementId: row.claimStatementId,
            status: status,
          },
        });
      } else if (title == "climant.revocateClimant") {
        res = await revokeClaimant({
          data: {
            claimStatementId: row.claimStatementId,
            status: status,
          },
        });
      } else {
        res = await toSubmitClaimant({
          data: {
            claimStatementId: row.claimStatementId,
            status: status,
          },
        });
      }
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("message.czcg"));
        this.getList();
      } else {
        this.$DonMessage.warning(res.message);
      }
    },
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.updateWindowHeight);
  },
};
</script>
<style lang="scss" scoped>
::v-deep .list .table-btn {
  margin-top: 0;
}
</style>
